<template>
  <div>
    <div v-if="!current_event || !current_event.event_id">
      Valitse event
    </div>
    <div v-else>
      <v-tabs
        v-if="showSecondPhaseTabs"
        v-model="tab"
      >
        <v-tab
          v-for="phaseTab in secondPhaseTabs"
          :key="phaseTab.value"
          :value="phaseTab.value"
        >
          {{ phaseTab.text }}
        </v-tab>
      </v-tabs>
      <div v-if="tab === 0" class="mt-3">
        <div v-if="showMeasureTimeControl">
          <v-switch
            :disabled="!current_event.marked"
            hide-details
            :input-value="event_data.measure_time"
            @change="setMeasureTime"
            label="Aika etenemisestä mitataan (Q)"
          />
        </div>
        <DynamicMap
          class="mt-5"
          @click="handleClick"
          :objects="point"
          v-if="map_bases.length"
          :image_url="chosen_map_base.url"
          :offsets="offsets"
          :maxWidth="800"
          :maxHeight="400"
        />
        <div v-if="showHitTypeControls" class="mt-3 d-flex justify-center">
          <div class="d-flex flex-column pa-1" :class="{ 'active-hotkey-column': tab === 0 }">
            <v-btn
              x-small
              outlined
              class="mt-1"
              style="width: 120px;"
              v-for="(item, i) in type_items"
              :key="item.value"
              @click="selectHitType(item.value)"
              :color="event_data.hit_type === item.value ? 'primary' : undefined"
              :class="{ 'selected-analysis-btn': event_data.hit_type === item.value }"
            >
              <span>
                {{ item.text }}
              </span>
              <span v-if="hotkeyLabel(i)" class="analysis-hotkey">
                {{ hotkeyLabel(i) }}
              </span>
            </v-btn>
            <div class="mt-3 d-flex justify-center">
              <v-icon @click="event_data.hit_type = null">mdi-close</v-icon>
            </div>
          </div>
        </div>
      </div>
      <div v-if="tab === 1" class="mt-3 d-flex justify-center">
        <div
          class="d-flex flex-column pa-1"
          :class="{ 'active-hotkey-column': tab === 1 }"
        >
          <v-btn
            v-for="(form, i) in formation_items"
            :key="form.value"
            outlined
            x-small
            class="mt-1 justify-space-between"
            style="width: 120px;"
            @click="selectFormation(form.value)"
            :color="event_data.outfield_formation === form.value ? 'primary' : undefined"
            :class="{ 'selected-analysis-btn': event_data.outfield_formation === form.value }"
          >
            <span>
              {{ form.text }}
            </span>
            <span v-if="hotkeyLabel(i)" class="analysis-hotkey">
              {{ hotkeyLabel(i) }}
            </span>
          </v-btn>
        </div>
      </div>
      <div class="mt-4">
        <v-chip label color="primary" v-if="showEventMeta && current_event.vaara_alla">Väärä alla</v-chip>
      </div>
      <div>
        <EventArrows v-if="!mapOnlyMode" @save="save" :disableEnterShortcut="[0, 1].includes(tab)"></EventArrows>
      </div>
    </div>
    <v-chip v-if="showEventMeta" class="mt-3">
      Tehty: {{ event_data.phase_done }}
    </v-chip>
  </div>
</template>

<script>
// import { mapActions, mapGetters, mapMutations } from 'vuex';
import DynamicMap from '../maps/DynamicMap.vue';
// import EventArrows from '@/components/analysis/analysis_components/EventArrows.vue';
import { mapActions, mapMutations, mapGetters } from 'vuex';
import EventArrows from '@/components/analysis/analysis_components/EventArrows.vue';

export default {
  name: 'HitMapAnalysis',
  created() {
    let analysisPhase = this.$route.query.analysis_phase
    if(analysisPhase) {
      const phaseTab = parseInt(analysisPhase.split('.')[1]) - 1
      this.tab = phaseTab === 1 ? 1 : 0
    }

    this.ensureVisibleTab()

    this.initLeagueMapBases({ league_id: this.video.league_id, open_type: 'field' })

    this.$nextTick(() => {
      this.setEmpty()
    })

    this.setEventsFilter()
  },
  shortcuts: {
    q: function() {
      if(!this.showMeasureTimeControl) return
      this.toggleMeasureTime()
    },
    w: function() {
      if(this.mapOnlyMode) return
      this.event_data.play_done = !this.event_data.play_done
    },
    e: function() {
      if(this.mapOnlyMode) return
      this.event_data.measure_play = !this.event_data.measure_play
    },
    c: function() {
      if(this.mapOnlyMode) return
      this.save()
    },
    keydown: function(e) {
      if(![0, 1].includes(this.tab) || e.shiftKey || e.ctrlKey || e.metaKey || e.altKey) return

      const keyCode = e.keyCode || e.which
      if(keyCode === 13) {
        if(this.mapOnlyMode) return
        this.save()
        e.preventDefault()
        return
      }

      const index = keyCode === 48 ? 9 : keyCode - 49
      if(index < 0 || index > 9) return

      this.handleColumnHotkey(index)
      e.preventDefault()
    }
  },
  data: () => ({
    tab: 2.1,
    event_data: {},
    empty_data: {
      // 2.1
      "hit_map_coordinates": { "x": null, "y": null },
      "measure_time": false,
      "measure_play": false,
      "play_done": false,
      // 2.2
      "hit_type": null, // nappi, pussari, vaakamaila, kumura, pomppu, viisto/pyke, kopinnosto, huti, jatkettu_nappi, muu
      // "nappi_type": null, // move to up-ajan mittaus
      // "hit_direction": "3-raja", // samma gamla vanliga
      "outfield_formation": null,
    },
    type_items: [
      { text: "Pyke/viisto", value: "pystari/viisto" },
      { text: "Vaakamaila", value: "vaakamaila" },
      { text: "Kumura", value: "kumura" },
      { text: "Näppi", value: "nappi" },
      { text: "Kopinnosto", value: "koppi" },
      { text: "Pomppu", value: "pomppu" },
      { text: "Pussari", value: "pussari" },
      { text: "Varsi", value: "varsi" },
      { text: "Huti", value: "huti" },
      { text: "Muu", value: "muu" },
    ],
    nappi_type_items: [
      { text: "Kääntönäppi", value: "kaanto" },
      { text: "Koukku", value: "koukku" },
      { text: "Vaakamaila", value: "vaaka" },
      { text: "Tuppi", value: "tuppi" },
      { text: "Huti", value: "huti" },
      { text: "Kirves", value: "kirves" },
      { text: "1 käden koukku", value: "y_koukku" },
      { text: "Muu", value: "muu" },
    ],
    direction_items: [
      { text: "3-raja", value: "three_raja" },
      { text: "3-luukku", value: "three_luukku" },
      { text: "3-sauma", value: "three_sauma" },
      { text: "3-jatke", value: "three_jatke" },
      { text: "3-pussi", value: "three_pussi" },

      { text: "Välimiespomppu", value: "valimiespomppu" },
      { text: "Menopomppu", value: "menopomppu" },
      { text: "Pomppu et. pel. yli", value: "etupelaaja_pomppu", explainer: "Pomppu, joka lyöty etupelaajan yli esimerkiksi takasen tahkoissa tai nollan käännetyssä." },
      { text: "Ylitysnäppi", value: "ylitysnappi" },
      { text: "Ohitus", value: "ohitus" },
      { text: "Tappi", value: "tappi" },
      { text: "Keski", value: "keski" },

      { text: "2-raja", value: "two_raja" },
      { text: "2-luukku", value: "two_luukku" },
      { text: "2-sauma", value: "two_sauma" },
      { text: "2-jatke", value: "two_jatke" },
      { text: "2-pussi", value: "two_pussi" },
    ],
  }),
  components: {
    DynamicMap,
    EventArrows
  },
  methods: {
    ...mapActions('map', [ 'initLeagueMapBases' ]),
    ...mapActions('player', [ 'seek' ]),
    ...mapActions('analysis', [ 'openPreviousEvent', 'openNextEvent' ]),
    ...mapMutations({
      'SET_SHOW_MEASURE_TAPE': 'analysis/SET_SHOW_MEASURE_TAPE',
      'SET_EVENTS_FILTER_FUNCTION': 'analysis/SET_EVENTS_FILTER_FUNCTION'
    }),
    handleClick({ x, y }) {
      this.event_data = {
        ...this.event_data,
        hit_map_coordinates: { x, y }
      }

      if(this.mapOnlyMode) {
        this.$nextTick(() => {
          this.save()
        })
      }
    },
    toggleMeasureTime() {
      this.event_data = {
        ...this.event_data,
        measure_time: !this.event_data.measure_time
      }
    },
    setMeasureTime(value) {
      this.event_data = {
        ...this.event_data,
        measure_time: value
      }
    },
    seekToEventStartForMapPhase() {
      if(this.tab !== 0) return
      if(!this.current_event?.starttime) return

      this.seek(Math.max(this.current_event.starttime - 1, 0))
    },
    hotkeyLabel(index) {
      if(index > 8) return null
      return String(index + 1)
    },
    selectFormation(value) {
      if(!this.showFormationControls) return
      this.event_data.outfield_formation = value
      this.save()
    },
    selectHitType(value) {
      if(!this.showHitTypeControls) return
      this.event_data.hit_type = value
      this.save()
    },
    handleColumnHotkey(index) {
      if(this.tab === 1) {
        if(!this.showFormationControls) return
        const formation = this.formation_items[index]
        if(!formation) return

        this.selectFormation(formation.value)
        return
      }

      if(!this.showHitTypeControls) return
      const hitType = this.type_items[index]
      if(hitType) this.selectHitType(hitType.value)
    },
    hasPlayerOnThirdForEvent(event) {
      if(event?.bases?.third?.id) return true
      return ['0-3', '1-3', '2-3', 'Ajo'].includes(event?.bases_state)
    },
    setEventsFilter() {
      if(this.showFormationControls && this.tab === 1) {
        this.SET_EVENTS_FILTER_FUNCTION((e) => !e.was_wrong && this.hasPlayerOnThirdForEvent(e))
        return
      }

      this.SET_EVENTS_FILTER_FUNCTION((e) => !e.was_wrong)
    },
    ensureVisibleTab() {
      if(!this.secondPhaseTabs.some(phaseTab => phaseTab.value === this.tab)) {
        this.tab = 0
      }
    },
    setEmpty(newVal) {
      newVal = newVal ? newVal : this.current_event
      if(newVal.phase_done > 1) {
        this.event_data = JSON.parse(JSON.stringify(newVal))
      } else {
        this.event_data = JSON.parse(JSON.stringify(this.empty_data))
      }
    },
    save() {
      const num = this.tab === 1 ? 2.2 : 2.3
      const new_event = {
        ...this.current_event,
        ...this.event_data,
        hit_map_base_id: this.chosen_map_base.id,
        phase_done: Math.max(this.current_event.phase_done, num)
      }

      this.$emit('eventSaved', new_event)
    }
  },
  computed: {
    ...mapGetters('map', [ 'map_bases', 'chosen_map_base' ]),
    ...mapGetters('videos', [ 'video', 'pesis_league_name' ]),
    ...mapGetters('analysis', [ 'current_event' ]),
    ...mapGetters('player', [ 'currentTime' ]),
    hasHitMapCoordinates() {
      return !!this.event_data?.hit_map_coordinates?.x && !!this.event_data?.hit_map_coordinates?.y
    },
    hasPlayerOnThird() {
      return this.hasPlayerOnThirdForEvent(this.current_event)
    },
    mapOnlyMode() {
      return this.pesis_league_name === 'nyp'
    },
    showSecondPhaseTabs() {
      return !this.mapOnlyMode && this.secondPhaseTabs.length > 1
    },
    showHitTypeControls() {
      return this.pesis_league_name !== 'nyp'
    },
    showFormationControls() {
      return !['myp', 'nyp'].includes(this.pesis_league_name)
    },
    showMeasureTimeControl() {
      return !this.mapOnlyMode
    },
    showEventMeta() {
      return !this.mapOnlyMode
    },
    secondPhaseTabs() {
      const tabs = [
        { value: 0, text: '2.1' }
      ]

      if(this.showFormationControls) {
        tabs.push({ value: 1, text: '2.2' })
      }

      return tabs
    },
    formation_items() {
      const state = this.current_event.bases_state
      if(state === '0') {
        return [
          { text: "Pertsa nolla", value: "nolla_pertsa" },
          { text: "Vasuri", value: "vasuri" },
          { text: "Oulu", value: "oulu" },
          { text: "Käännetty", value: "kaannetty" },
          { text: "3-puolen kääntö", value: "kolmospuolen_kaanto" },
          { text: "1-v irti", value: "1v_irti" },
        ]
      } else if (['1', '2', '1-2', '0-2', ''].includes(state)) {
        return [
          { text: "Normaali", value: "normaali" },
          { text: "Syvä pussi", value: "syvapussi" },
          { text: "Säilytys vaihto", value: "sailytys_vaihto" },
          { text: "Kasari", value: "kasari" },
          { text: "Nol. kuv. vaihtotilanteessa", value: "nolla_vaihdossa" },
        ]
      }

      // takanen
      return [
        { text: "Oulu", value: "oulu" },
        { text: "Pertsa", value: "pertsa" },
        { text: "Käännetty oulu", value: "kaannetty_oulu" },
        { text: "Käännetty pertsa", value: "kaannetty_pertsa" },
        { text: "Tahko", value: "tahko" },
        { text: "Vasurin tahko", value: "vasurin_tahko" },
        { text: "Säilytys takanen", value: "sailytys_takanen" },
        { text: "Karvaus yhdellä", value: "karvaus_yksi" },
        { text: "Karvaus kahdella", value: "karvaus_kaksi" },
        { text: "Ykköstilannekarvaus", value: "karvaus_ykkostilanne" },
      ]
    },
    mapBase() {
      return  this.map_bases ? this.map_bases[0] : null
    },
    offsets() {
      if(!this.mapBase) return {}

      return {
        top: this.mapBase.offset_top,
        bottom: this.mapBase.offset_bottom,
        left: this.mapBase.offset_left,
        right: this.mapBase.offset_right
      }
    },
    point() {
      if(!this.event_data.hit_map_coordinates?.x || !this.event_data.hit_map_coordinates?.y) return []

      let color;
      if(this.current_event.hit_outcome === 'palo') {
        color = 'red'
      } else if(this.current_event.hit_outcome === 'karkilyonti') {
        color = 'green'
      } else if(this.current_event.hit_outcome === 'haava') {
        color = 'yellow'
      } else {
        color = 'grey'
      }

      return [
        {
          x: this.event_data.hit_map_coordinates.x,
          y: this.event_data.hit_map_coordinates.y,
          color,
          strokeWidth: 2,
          strokeColor: 'black',
          size: 4,
          opacity: 1,
          shape: this.current_event.marked ? 'circle' : 'square'
        }
      ]
    },
  },
  watch: {
    tab: {
      handler() {
        this.ensureVisibleTab()
        this.setEventsFilter()
        this.seekToEventStartForMapPhase()
      }
    },
    current_event: {
      handler(newVal) {
        this.setEmpty(newVal)
        this.$nextTick(() => {
          this.seekToEventStartForMapPhase()
        })
      },
      immediate: true
    },
    currentTime: {
      handler(newVal) {
        if(!this.current_event || !this.current_event.event_id) return
        if(this.current_event && newVal > this.current_event.endtime) {
          this.seek(this.tab === 0 ? Math.max(this.current_event.starttime - 1, 0) : this.current_event.starttime - 3)
        }
      }
    }
  }
}
</script>

<style scoped>
.selected-analysis-btn {
  background-color: #2C57FB !important;
  border-color: #1237c8 !important;
  color: white !important;
  font-weight: 700;
  box-shadow: 0 0 0 2px rgba(44, 87, 251, 0.35);
}

.analysis-hotkey {
  color: #888;
  font-size: 10px;
  margin-left: 6px;
}

.active-hotkey-column {
  border: 2px solid rgba(44, 87, 251, 0.35);
  border-radius: 6px;
}
</style>